<template>
	<div class="app-container mianInfo">
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{pageName}}</h3>
			</div>

			<el-button type="primary" icon="el-icon-plus" @click="handleAdd" class="mb20">添加教学分类</el-button>

			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="编号" align="center" prop="id" width="60" />
				<el-table-column label="分类名称" align="center" prop="teachingTypeName" />
				<el-table-column label="发布人员" align="center" prop="createBy" />
				<el-table-column label="发布时间" align="center" prop="createTime" />
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width">
					<template slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="_getList" />

			<el-dialog :title="dialogTit" :visible.sync="dialogShow" width="600px" append-to-body>
				<el-form ref="setform" :model="setParams" size="mini" :rules="rules" label-width="120px">
					<el-form-item label="教学分类名称:" prop="teachingTypeName">
						<el-input v-model="setParams.teachingTypeName" placeholder="输入教学分类名称" clearable
							@keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="cancel">取 消</el-button>
					<el-button type="primary" @click="submitForm">确认</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	import * as API_Teach from "@/api/sportManage/teach";

	export default {
		name: "userIndex",
		data() {
			return {
				pageName: '教学分类',

				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				list: [],
				total: 0,
				loading: false,

				dialogShow: false,
				dialogTit: '设备类型',
				setParams: {},
				rules: {
					teachingTypeName: [{
						required: true,
						message: "输入教学分类名称",
						trigger: "change"
					}],
				}
			};
		},
		created() {
			this._getList()
		},
		methods: {
			// 接口-教学分类列表
			_getList() {
				this.loading = true
				API_Teach.typeList(this.queryParams).then((res) => {
					this.loading = false
					this.total = res.data.total;
					this.list = res.data.list;
				}).catch((err) => {

				});
			},
			// 接口-新增分类
			_addType() {
				API_Teach.addType(this.setParams).then((res) => {
					console.log(res.data);
					this.$message({
						message: "操作成功",
						type: "success",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},
			// 接口-编辑分类
			_editType() {
				API_Teach.editType(this.setParams).then((res) => {
					console.log(res.data);
					this.$message({
						message: "操作成功",
						type: "success",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},
			// 接口-删除分类
			_delType(id) {
				API_Teach.delType(id).then((res) => {
					console.log(res.data);
					this.$message({
						message: "已删除",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},

			// 刷新列表
			handleRefresh() {
				this.queryParams.pageNum = 1;
				this._getList();
			},
			// 新增教学分类
			handleAdd() {
				this.dialogShow = true;
				this.clear()
				this.setParams = {};
				this.dialogTit = '添加教学分类'
			},
			// 编辑教学
			handleEdit(row) {
				this.dialogShow = true
				this.clear();
				this.dialogTit = '编辑教学分类'
				this.setParams = JSON.parse(JSON.stringify(row));
			},
			//删除提示
			handleDel(e) {
				console.log(e);
				this.$confirm(`确定删除该分类？`, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this._delType(e.id)
					})
					.catch(() => {});
			},
			//提交按钮
			submitForm() {
				this.$refs['setform'].validate((valid) => {
					if (valid) {
						this.dialogShow = false
						this.clear()
						this.setParams.id ? this._editType() : this._addType()
					} else {
						console.log('error submit!!');
						this.$message({
							message: '填写数据不全或数据有误',
							type: 'error'
						});
						return false;
					}
				});
			},
			// 弹窗-取消
			cancel() {
				this.setParams = {}
				this.dialogShow = false
				this.clear()
			},
			clear() {
				this.$nextTick(() => {
					this.$refs['setform'].clearValidate();
				})
			}
		},
	};
</script>

<style scoped lang="scss">
	@import "../../../assets/styles/common.scss";
</style>